
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    colMd4: {
        width: '33.3334%',
        float: 'left',
        paddingLeft: '12px',
        paddingRight: '12px'
    },
    colMd6: {
        width: '50%',
        float: 'left',
        paddingLeft: '12px',
        paddingRight: '12px'
    },
    colMd12: {
        width: '100%',
        float: 'left',
        paddingLeft: '12px',
        paddingRight: '12px'
    },
    filterContainer: {
        position: 'relative',
        marginBottom: '25px',
        ':before': {
            content: '" "',
            display: 'table'
        },
        ':after': {
            content: '" "',
            display: 'table',
            clear: 'both'
        },
        ':last-child': {
            marginBottom: '0'
        }
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/styles.js